<template>
  <button
    class="circle-button"
    @click="handleModal"
  >
    <img
      v-if="!showModal"
      src="@/assets/images/chat_bubble.svg"
      alt="Circle Image"
      class="circle-button-image"
    >
    <v-icon
      v-else
      color="#ef4135"
    >
      mdi-close
    </v-icon>
  </button>
</template>

<script>
export default {
    props: {
        isPopUpOpen: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            showModal: false,
        };
    },
    watch: {
        isPopUpOpen(value) {
            if (value) {
                this.handleModal();
            }
        },
    },
    methods: {
        handleModal() {
            this.showModal = !this.showModal;
            if (this.showModal) {
                this.openModal();
            } else {
                this.closeModal();
            }
        },
        openModal() {
            this.$emit('open-modal');
        },
        closeModal() {
            this.$emit('close-modal');
        },
    },
};
</script>

<style scoped>
.circle-button {
  position: fixed;
  bottom: 30px;
  right: 35px;
  z-index: 7;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #fff;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}
@media (max-width: 1000px) {
  .circle-button {
    bottom: 20px;
    right: 20px;
  }
}
.circle-button-image {
  width: 70%;
  height: 80%;
  object-fit: contain;
  border-radius: 50%;
}
</style>
